import service from '@/router/request';

/**
 * 分页查询项目
 * @param params 查询条件
 */
export async function pageProjects(params) {
  const res = await service.get('/bus/project/page', {
    params
  });
  if (res.data.code === 0) {
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 查询项目详情
 * @param id 查询条件
 */
export async function getProjectDataApi(id) {
  const res = await service.get('/bus/project/' + id);
  if (res.data.code === 0) {
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 添加项目
 * @param data 项目信息
 */
export async function addProject(data) {
  const res = await service.post('/bus/project', data);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 修改项目
 * @param data 项目信息
 */
export async function updateProject(data) {
  const res = await service.put('/bus/project', data);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 删除项目
 * @param id 项目id
 */
export async function removeProject(id) {
  const res = await service.delete('/bus/project/' + id);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 查询评委
 * @param params 查询条件
 */
export async function pageUsers(params) {
  const res = await service.get('/bus/experts/page', {
    params
  });
  if (res.data.code === 0) {
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 指定专家
 * @param data 信息
 */
export async function assignUserApi(data) {
  const res = await service.post('/bus/projectExperts/addBatch', data);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}